/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramInternalTransactionsUserControllerFindAllQueryResponse,
  TelegramInternalTransactionsUserControllerFindAllQueryParams,
  TelegramInternalTransactionsUserControllerFindAll401,
} from '../../types/TelegramInternalTransactionsUserControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramInternalTransactionsUserFindAll } from '../../methods/telegramInternalTransactionsUserFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramInternalTransactionsUserFindAllQueryKey = (
  params?: TelegramInternalTransactionsUserControllerFindAllQueryParams,
) => [{ url: '/api/user/telegram/internal-transactions' }, ...(params ? [params] : [])] as const;

export type TelegramInternalTransactionsUserFindAllQueryKey = ReturnType<
  typeof telegramInternalTransactionsUserFindAllQueryKey
>;

export function telegramInternalTransactionsUserFindAllQueryOptions(
  params?: TelegramInternalTransactionsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramInternalTransactionsUserFindAllQueryKey(params);
  return queryOptions<
    TelegramInternalTransactionsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramInternalTransactionsUserControllerFindAll401>,
    TelegramInternalTransactionsUserControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramInternalTransactionsUserFindAll(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/internal-transactions}
 */
export function useTelegramInternalTransactionsUserFindAll<
  TData = TelegramInternalTransactionsUserControllerFindAllQueryResponse,
  TQueryData = TelegramInternalTransactionsUserControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramInternalTransactionsUserFindAllQueryKey,
>(
  params?: TelegramInternalTransactionsUserControllerFindAllQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramInternalTransactionsUserControllerFindAllQueryResponse,
        ResponseErrorConfig<TelegramInternalTransactionsUserControllerFindAll401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramInternalTransactionsUserFindAllQueryKey(params);

  const query = useQuery(
    {
      ...telegramInternalTransactionsUserFindAllQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramInternalTransactionsUserControllerFindAll401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
